import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardUser from './CardUser';
import { getAllusers } from '../Redux/Actions/AuthActions';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Register from './Register';

const ListUser = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllusers());
  }, [dispatch]);

  const userList = useSelector((state) => state.AuthReducer?.users || state.AuthReducer?.Users || []);

  return (
    <Container className="my-5" style={{ paddingTop: "70px" }}>
      <Row className="g-4">
        <Col xs={12} lg={5}>
          <div className="p-3 bg-dark rounded shadow-sm text-white border border-secondary">
            <h4 className="mb-3 text-primary fw-bold">Ajouter un Utilisateur</h4>
            <Register />
          </div>
        </Col>
        <Col xs={12} lg={7}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="text-white fw-bold mb-0">
              👥 Utilisateurs ({userList ? userList.length : 0})
            </h3>
          </div>
          <Row className="g-3">
            {userList && userList.length > 0 ? (
              userList.map((el) => (
                <Col key={el._id || el.id} xs={12} sm={6}>
                  <CardUser el={el} />
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <div className="alert alert-info text-center py-4">
                  Aucun utilisateur trouvé.
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default ListUser;
